<script>
  import SimpleAvatar from '@app-components/modal/create_account/SimpleAvatar.svelte';
  import Text from '@components/Text.svelte';
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';
  import RequestAccessAjax from '@ajax/request_access';
  import UserFollowButton from './UserFollowButton.svelte';
  import Notification from '@utils/notification';
  import Track from '@utils/track';

  export let notificationClicked;
  export let notification;
  export let mobile;
  export let user;

  let relatedUser = notification.related_user;
  let hasFollowButton = notification.button_style == 'follow_button';
  let requestAccess = notification.request_access;
  let relatedGroups = notification.related_groups;
  let visibleRelatedGroups = null;
  let showMoreCount = null;
  let relatedRecObjects = notification.related_rec_objects;

  if (relatedGroups.length > 0) {
    visibleRelatedGroups = relatedGroups.slice(0, 2);
    if (relatedGroups.length > 2) {
      showMoreCount = relatedGroups.length - 2;
    }
  }

  const showAllGroups = function () {
    showMoreCount = null;
    visibleRelatedGroups = relatedGroups;
  };

  let acceptRequest = async function () {
    try {
      await RequestAccessAjax.accept(requestAccess.group_base_id, requestAccess);
      requestAccess = { ...requestAccess, status: 'accepted' };
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }
  };

  let declineRequest = async function () {
    try {
      await RequestAccessAjax.decline(requestAccess.group_base_id, requestAccess);
      requestAccess = { ...requestAccess, status: 'declined' };
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }
  };

  const notificationTitleExceedsCutoff = () => {
    let cutoff_length = 19;
    if (relatedUser.verified) {
      cutoff_length - 1;
    }
    if (relatedUser && hasFollowButton) {
      cutoff_length - 3;
    }

    return notification.title.length > cutoff_length;
  };

  let goToRecObject = (ro) => {
    Track.notificationsItemClick({
      notification: notification,
      recObject: ro,
      itemType: 'recobject',
    });

    location.href = ro.path;
  };

  let goToGroup = (group) => {
    Track.notificationsItemClick({
      notification: notification,
      group: group,
      itemType: 'group',
    });

    location.href = group.path;
  };
</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 8px;
  }
  .btn {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    padding: 6px 16px;
    border-radius: 10px;
    &.accept-btn {
      background: #ae94f9;
      color: white;
      &:hover {
        opacity: 0.8;
      }
    }
    &.accepted {
      background: #e7f9f3;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      img {
        height: 12px;
        width: 12px;
      }
    }
    &.decline-btn {
      background: #fff4f5;
      color: #ff5567;
      &:hover {
        opacity: 0.8;
      }
    }
    &.declined {
      background: #fff4f5;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      img {
        height: 12px;
        width: 12px;
      }
    }
  }

  .single-notification-emoji {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    background: #f5f3fc;
    border-radius: 999px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s all;

    img {
      width: 20px;
      height: 20px;
    }
    &.single-notification-avatar {
      background: none;
      border-radius: 0px;
    }
  }

  .single-notification-clicked-dot {
    margin-top: 3px;
    background: $red-pink;
    border-radius: 8px;
    width: 8px;
    height: 8px;
    position: absolute;
    padding: 2px;
    box-shadow: 0px 0px 0px 2px white;
    left: 3px;
    top: 0px;
    z-index: 5;
    &.emoji {
      left: -8px;
      top: -10px;
    }
  }

  .single-notification-middle {
    margin-left: 12px;
    text-align: left;
    font-style: normal;
    font-size: 14px;
    line-height: 16px;
    &.non-follow {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 1;
    }

    .single-notification-text {
      color: $black;
      font-size: 14px;
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical;
      padding-bottom: 2px;
      position: relative;

      &.right-image {
        padding-right: 64px;
        min-height: 48px;
      }
      &.right-display-amount {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 0px;
        gap: 8px;
      }

      .item-image {
        width: 60px;
        height: 48px;
        position: absolute;
        right: 0;
        top: 0;
        border-radius: 6px;
      }

      .display-amount {
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #2caf87;
        background: #e7f9f3;
        border-radius: 16px;
        padding: 4px 12px;
        width: auto;
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .single-notification-title {
        font-weight: 700;
        word-break: break-word;

        &.single-notification-username {
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          display: -webkit-box;
        }
      }

      .single-notification-headline {
        font-weight: 400;
        word-break: break-word;
      }
    }

    .single-notification-date {
      font-size: 14px;
      line-height: 18px;
      color: #7f7f7f;
    }

    .comment {
      background: #f9f7ff;
      padding: 8px 16px;
      border-radius: 8px;
      line-height: 20px;
      color: #5e518e;
      &.original {
        color: #7f7f7f;
        background: transparent;
        padding: 8px 0 0;
        font-style: italic;
        line-height: 20px;
      }
      &.grey-background {
        background: #f5f5f5;
        color: black;
      }
      &.tooltip-left {
        position: relative;
        margin-left: 6px;

        &:after {
          content: ' ';
          display: block;
          position: absolute;
          top: 0;
          left: -7px;
          width: 0;
          height: 0;
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 14px solid #f9f7ff;
        }
      }
    }
  }

  .avatar-wrapper {
    z-index: 2;
    position: relative;
  }

  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px;
    gap: 12px;
    background: #ffffff;
    box-shadow: 0px 2.81023px 17.564px rgba(0, 0, 0, 0.16);
    border-radius: 6px;
    .item-image {
      width: 60px;
      height: 48px;
      border-radius: 6px;
      align-self: flex-start;
    }
    .right-side {
      flex: 1;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      .title {
        margin-bottom: 4px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .count {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px;
        gap: 6px;
        color: #7f7f7f;
        .star {
          width: 12px;
          height: 12px;
        }
      }
    }
  }

  .list-items {
    .item {
      margin-bottom: 8px;
    }
    .more-items a {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      color: #ae94f9;
    }
  }

  .new-items {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    &.multiple {
      align-items: flex-start;
      gap: 8px;
    }
    .item-image {
      width: 60px;
      height: 48px;
      border-radius: 6px;
      object-fit: cover;
      object-position: center;
    }
    .right-side {
      flex: 1;
      .title {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
      }
    }
  }

  * :global(.bn-button.btn-small) {
    margin-top: 7px !important;
  }

  * :global(.uneditable-content) {
    margin-bottom: -5px !important;
  }
</style>

{#if relatedUser}
  <div class="single-notification-emoji single-notification-avatar">
    <div style="display: block; position: relative">
      {#if !notification.clicked}
        <div class="single-notification-clicked-dot" />
      {/if}
      <div class="avatar-wrapper">
        <SimpleAvatar
          width={40}
          height={40}
          mobile={mobile}
          src={relatedUser.avatar_url}
          href={relatedUser.profile_path}
          user={relatedUser} />
      </div>
    </div>
  </div>
{:else}
  <div class="single-notification-emoji single-notification-icon">
    <div style="display: block; position: relative">
      {#if !notification.clicked}
        <div class="single-notification-clicked-dot emoji" />
      {/if}
      <img alt="emoji" src={notification.emoji} />
    </div>
  </div>
{/if}
<div class="single-notification-middle {hasFollowButton ? 'follow' : 'non-follow'}" class:mobile={mobile}>
  <div
    class="single-notification-text {notification.display_amount ? 'right-display-amount' : ''} {notification.item_image
      ? 'right-image'
      : ''}">
    <div>
      {#if relatedUser}
        <span
          class="single-notification-title {notificationTitleExceedsCutoff() ? 'single-notification-username' : ''}">
          <AccountVerifiedIcon
            dimension={12}
            verified={relatedUser.verified}
            clickable={true}
            on:areaClicked={() => notificationClicked(notification)}
            extraStyle={'display: inline'}
            extraStyleIcon={'display: inline; vertical-align: middle; margin-right: 4px'}>
            <svelte:fragment slot="account-name">
              {notification.title}
            </svelte:fragment>
          </AccountVerifiedIcon>
        </span>
      {:else}
        <span class="single-notification-title">{notification.title} </span>
      {/if}

      {#if notification.headline}
        <span class="single-notification-headline">{notification.headline}</span>
      {/if}
      <span class="single-notification-date">{notification.display_ts}</span>

      {#if notification.item_image}
        <img class="item-image" src={notification.item_image} alt="" />
      {/if}
    </div>
    {#if notification.display_amount}
      <span class="display-amount">
        <span>+</span>
        &nbsp;{notification.display_amount}
      </span>
    {/if}
  </div>
  {#if notification.comment}
    <div class="comment {notification.comment.reply ? 'original' : 'tooltip-left'}">
      <Text text={notification.comment.body} collapseAfterExpand={false} />
    </div>
    {#if notification.comment.reply}
      <div class="comment tooltip-left">
        <Text text={notification.comment.reply} collapseAfterExpand={false} />
      </div>
    {/if}
  {/if}

  {#if requestAccess}
    <div class="btn-wrapper">
      {#if requestAccess.status}
        {#if requestAccess.status == 'accepted'}
          <span class="btn accepted"><img src="/images/checkmark.png" alt="" />Accepted</span>
        {:else}
          <span class="btn declined"><img src="/images/close.png" alt="" />Declined</span>
        {/if}
      {:else}
        <a
          href="/"
          on:click|preventDefault|stopPropagation={() => {
            acceptRequest();
          }}
          class="btn accept-btn">
          Accept
        </a>
        <a
          href="/"
          on:click|preventDefault|stopPropagation={() => {
            declineRequest();
          }}
          class="btn decline-btn">
          Decline
        </a>
      {/if}
    </div>
  {/if}

  {#if visibleRelatedGroups}
    <div class="list-items">
      {#each visibleRelatedGroups as relatedGroup}
        <div
          class="item"
          on:click|preventDefault|stopPropagation={() => {
            goToGroup(relatedGroup);
          }}>
          <img
            class="item-image"
            src={relatedGroup.minified_cover_image || '/emojis/purple_star.png'}
            alt="{relatedGroup.name} cover photo collage" />
          <div class="right-side">
            <div class="title">{relatedGroup.name}</div>
            <div class="count">
              <img class="star" src="/emojis/purple_star.png" alt="" />
              <span>{relatedGroup.items_count}</span>
            </div>
          </div>
        </div>
      {/each}
      {#if showMoreCount}
        <div class="more-items">
          <a
            href="#"
            on:click|preventDefault|stopPropagation={() => {
              showAllGroups();
            }}>+ {showMoreCount} more</a>
        </div>
      {/if}
    </div>
  {/if}

  {#if relatedRecObjects}
    <div class="new-items {relatedRecObjects.length > 1 ? 'multiple' : ''}">
      {#if relatedRecObjects.length > 1}
        {#each relatedRecObjects as ro}
          {#if ro.photo}
            <img
              on:click|preventDefault|stopPropagation={() => {
                goToRecObject(ro);
              }}
              class="item-image"
              src={ro.photo}
              alt="" />
          {/if}
        {/each}
      {:else}
        <img
          on:click|preventDefault|stopPropagation={() => {
            goToRecObject(relatedRecObjects[0]);
          }}
          class="item-image"
          src={relatedRecObjects[0].photo}
          alt="" />
        <div
          on:click|preventDefault|stopPropagation={() => {
            goToRecObject(relatedRecObjects[0]);
          }}
          class="right-side">
          <div class="title">{relatedRecObjects[0].name}</div>
        </div>
      {/if}
    </div>
  {/if}

  {#if notification.message}
    <div class="comment tooltip-left grey-background">{notification.message}</div>
  {/if}
</div>

{#if relatedUser && hasFollowButton}
  <div class="single-notification-right" style="flex-grow: 1; margin-left: 12px">
    <div style="float:right">
      <UserFollowButton
        profileUser={user}
        width={'104px'}
        user={relatedUser}
        size={'small'}
        context={'notification_menu'} />
    </div>
  </div>
{/if}
